<template>
	<div class="order_list">
		<van-tabs
			v-model="active"
			background="transparent"
			color="#000"
			@change="activeChange"
		>
			<van-tab title="全部" name=""></van-tab>
			<van-tab title="待支付" name="0"></van-tab>
			<van-tab title="待送检" name="4"></van-tab>
			<van-tab title="送检中" name="1"></van-tab>
			<van-tab title="检测中" name="2"></van-tab>
			<van-tab title="已完成" name="3"></van-tab>
			<van-tab title="交易关闭" name="99"></van-tab>
		</van-tabs>

		<div class="content">
			<van-list
				v-if="total"
				v-model="loading"
				:finished="finished"
				finished-text="没有更多了"
				@load="getList"
			>
				<order-card
					class="mt-28"
					v-for="item in list"
					:key="item.id"
					:order-id="item.number"
					:status="item.detectStatus"
					:list="item._list"
					:total-price="item.totalPrice"
					:sample-type="item._sampleType"
					:total-info="{
						totalNum: item._listNum,
						totalPrice: item._listTotalPrice
					}"
					@pay="clickPay(item)"
					@click="$router.push(`/order/detail/${ item.id }`)"
					@report="$router.push(`/report/view-report/${ item.id }`)"
				/>
			</van-list>
			<base-empty v-else desc="暂无订单" :icon="0"></base-empty>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'orderList',
		data: () => ({
			active: 0,
			loading: false,
			detectStatus: '',
			list: [],
			total: 0,
			page: 1,
			limit: 10
		}),
		computed: {
			finished () {
				return this.total <= this.list.length
			}
		},
		created (){
			this.getList()
		},
		methods: {
			// 切换 tab
			activeChange (name) {
				this.detectStatus = name
				this.list = []
				this.page = 1
				this.total = 0
				this.getList()
			},
			async getList () {
				this.loading = true
				const res = await this.$api.order.page({
					limit: this.limit,
					page: this.page,
					detectStatus: this.detectStatus,
					order: 'desc',
					orderField: 'create_time'
				})
				this.loading = false
				if (!res.code) {
					res.data.list.forEach(item => {
						item._list = this.listDataFormat(item) || []
						item._listNum = `共${ (item.productList || []).length}件`
						item._listTotalPrice = (item.productList || []).reduce((v, d) => (v + d.totalPrice), 0)
						item._sampleType = (item.detectType || '').split('&').map(val => ({ 1: '血液', 2: '脑脊液' }[val])).join('+')
					})
					this.list = [...this.list, ...res.data.list]
					this.total = res.data.total
					this.page ++
				}
			},
			// list 数据转化
			listDataFormat (data) {
				return (data.productList || []).map(item => ({
					...item,
					title: item.productName,
					content: (item.itemList || []).map(val => val.itemName).join('、'),
					desc: [{ label: `￥${ item.totalPrice }`, value: `x${ item.quantity }` }]
				}))
			},
			// 点击立即购买
			clickPay (item) {
				this.$wx.wxPay({
          appId: this.$config.appid,
					idCard: item.patientIdcard,
					name: item.patientName,
					openId: this.$store.getters['account/getOpenid'],
					orderId: item.id,
	        callBackUrl: window.location.origin
		           + `/static/pay-result/index.html?url=`
		           + decodeURIComponent(`/order/detail/${ item.id }`)
		           + `&err=`
		           + decodeURIComponent(`/order/detail/${ item.id }`)
	              + `&orderId=${item.id}`
				}, (res) => {
	        window.location.href = res.data.webPayUrl;
					// this.activeChange(this.detectStatus)
				})
			}
		}
	};
</script>

<style scoped lang="less">
	.order_list {
		padding: 18px 32px;
	}
</style>

<style lang="less">
	.order_list {
		.van-tabs {
			.van-tabs__line{ height: 4px; }
			.van-tab {
				.van-tab__text {
					font-family: PingFangSC-Regular;
					font-size: 32px;
					font-weight: normal;
					text-align: center;
					color: #BBBFC4;
				}
				&.van-tab--active {
					.van-tab__text {
						color: #000;
					}
				}
			}
		}
	}
</style>